<template>
    <div class="qkdetail clearfix">
        <div class="qkdetail-top">
            您的当前位置：首页&lt;期刊&lt;{{ detailData.title }}
        </div>
        <div class="detail-left">
            <div class="intro-top flex-row">
                <div class="intro-img">
                    <img :src="detailData.coverImg" :alt="detailData.title" />
                </div>
                <div class="intro-text">
                    <h2>{{ detailData.title }}</h2>
                    <p class="auth">作者：{{ detailData.author }}</p>
                    <p class="time">
                        发布时间：{{ detailData.createTime.time | dateFormat }}
                    </p>
                    <p class="desc-title">期刊简介：</p>
                    <p class="desc">{{ detailData.title }}</p>
                </div>
            </div>

            <!-- <embed :src="detailData.annex" width="650px" height="800px"> -->
            <iframe :src="detailData.annex" width="650px" height="800px" frameborder="1" scrolling="auto" style="padding-bottom:30px;border:none"></iframe>
            <!-- <div class="editer weui-article" v-html="detailData.content"></div> -->
        </div>
        <div class="detail-right">
            <h2>周排行榜</h2>
            <div class="new-list">
                <p
                    @click="goQkDetail(item)"
                    v-for="(item, index) in newQkData"
                    :key="index"
                    class="new-item flex-row"
                >
                    <span>
                        <b>{{ index + 1 }}</b>
                        {{ item.title }}
                    </span>
                    <span>{{ item.createTime.time | dateFormat }}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "qkdetail",
    data() {
        return {
            detailData: {
                createTime: ""
            },
            newQkData: []
        };
    },
    created() {
        this.getDetail(this.$route.query.id);
        this.getNewQkData();
    },
    methods: {
        getDetail(id) {
            if (id) {
                this.$ajax({
                    url: "homePage/getPeriodicalById",
                    method: "post",
                    data: {
                        id: id
                    },
                    success: res => {
                        // console.log(res);
                        if (res.code == 200) {
                            this.detailData = res.message;
                        }
                    }
                });
            }
        },
        getNewQkData() {
            this.$ajax({
                method: "post",
                url: "homePage/getPeriodical",
                data: {
                    curren: 1
                },
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 10
                            ? (res.message.records.length = 10)
                            : "";
                        this.newQkData = res.message.records;
                    }
                },
                error: res => {}
            });
        },
        goQkDetail(item) {
            this.$router.push({
                name: "qkdetail",
                query: {
                    id: item.id,
                    title: item.title
                }
            });
        }
    },
    watch: {
        "$route.query.id": function(nval) {
            this.getDetail(nval);
        }
    }
};
</script>

<style lang="scss" scoped>
.qkdetail {
    width: 1000px;
    min-height: 500px;
    margin: 0 auto;
    pa
    .qkdetail-top {
        width: 1000px;
        height: 40px;
        color: #999;
    }
    .detail-left {
        width: 680px;
        float: left;
        .intro-top {
            width: 100%;
            margin-bottom: 20px;
            .intro-img {
                width: 150px;
                height: 200px;
                border: 1px solid #ddd;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .intro-text {
                flex: 1;
                height: 200px;
                padding-left: 20px;
                h2 {
                    font-size: 18px;
                    line-height: 25px;
                    font-weight: bold;
                }
                p {
                    line-height: 18px;
                    height: 18px;
                    font-size: 14px;
                }
                .auth {
                    margin-top: 7px;
                }
                .time {
                    margin-bottom: 12px;
                }
                .desc {
                    height: 100px;
                    line-height: 20px;
                    overflow: hidden;
                }
            }
        }
        .editer {
            width: 680px;
        }
    }
    // 右侧周排行榜
    .detail-right {
        width: 300px;
        float: right;
        h2 {
            padding: 5px 10px;
            border: 1px solid #ddd;
            border-top: 2px solid #0099cc;
            width: 80px;
            text-align: center;
            position: relative;
            z-index: 1;
            font-weight: bold;
            background-color: #fff;
            border-bottom: 0;
        }
        .new-list {
            position: relative;
            width: 100%;
            min-height: 30px;
            background-color: #fff;
            border: 1px solid #ddd;
            margin-top: -1px;
            .new-item {
                line-height: 40px;
                height: 40px;
                padding: 0 10px;
                justify-content: space-between;
                font-size: 14px;
                cursor: pointer;
                span:nth-child(1) {
                    display: inline-block;
                    max-width: 180px;
                    height: 40px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                b {
                    margin-right: 8px;
                }
            }
            .new-item:hover {
                background-color: rgba(200, 200, 200, 0.3);
            }
        }
        .new-list:after {
            content: "";
            height: 40px;
            background-color: #0099cc;
            width: 2px;
            position: absolute;
            bottom: 0;
            left: -1px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shouye/qkdetail.vue